import React, { useLayoutEffect, useMemo } from "react";
import { NavigationClient } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

export class RouterNavigationClient extends NavigationClient {
  constructor(navigate) {
    super();
    this.navigate = navigate;
  }

  async navigateInternal(url, options) {
    const target = new URL(url, window.location.href);
    if (target.origin !== window.location.origin) {
      return super.navigateInternal(url, options);
    }

    this.navigate(`${target.pathname}${target.search}${target.hash}`, { replace: options.noHistory });
    // MsalProvider stays mounted, so MSAL must process the response here,
    // rather than wait for another page load to handle the redirect.
    return false;
  }
}

export default function MsalRouterProvider({ instance, children }) {
  const navigate = useNavigate();
  const navigationClient = useMemo(() => new RouterNavigationClient(navigate), [navigate]);

  useLayoutEffect(() => {
    // Install before MsalProvider handles the redirect in its passive effect.
    instance.setNavigationClient(navigationClient);
  }, [instance, navigationClient]);

  return <MsalProvider instance={instance}>{children}</MsalProvider>;
}
